import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import dayjs from 'src/utils/dayjs';
import { DEFAULT_ERROR_MESSAGE } from 'src/utils/constants';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getErrorMessage(error) {
  return error?.response?.data?.message || DEFAULT_ERROR_MESSAGE;
}

export function formatDate(value, fallback = '—') {
  if (!value) return fallback;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : fallback;
}

export function formatDateTime(value, fallback = '—') {
  if (!value) return fallback;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : fallback;
}

export function formatCurrency(value, fallback = '—') {
  if (value === null || value === undefined || value === '') return fallback;
  const amount = Number(value);
  if (Number.isNaN(amount)) return fallback;
  return `${amount.toLocaleString('fr-DZ')} DA`;
}

export function formatPriceRange(minPrice, maxPrice, fallback = '—') {
  if (minPrice === null || minPrice === undefined || maxPrice === null || maxPrice === undefined) {
    return fallback;
  }
  const min = Number(minPrice);
  const max = Number(maxPrice);
  if (Number.isNaN(min) || Number.isNaN(max)) return fallback;
  return `${min.toLocaleString('fr-DZ')} – ${max.toLocaleString('fr-DZ')} DA`;
}

// Dispatches on a prestation's pricingType: a plain amount for FIXED, "min – max DA" for RANGE.
// Never averages a range into a single number.
export function formatServicePrice({ pricingType, price, minPrice, maxPrice } = {}, fallback = '—') {
  if (pricingType === 'RANGE') return formatPriceRange(minPrice, maxPrice, fallback);
  return formatCurrency(price, fallback);
}

export function clientName(client) {
  if (!client) return '—';
  if (client.fullName) return client.fullName;
  const name = [client.firstName, client.lastName].filter(Boolean).join(' ');
  return name || '—';
}

export function toTimeInputValue(value) {
  if (value == null || value === '') return '09:00';
  if (typeof value === 'string') {
    const plain = value.trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
    if (plain) return `${plain[1].padStart(2, '0')}:${plain[2]}`;
  }
  const parsed = dayjs.isDayjs(value) ? value : dayjs(value);
  return parsed.isValid() ? parsed.format('HH:mm') : '09:00';
}

export function fromTimeInputValue(value) {
  const [hour, minute] = String(value || '09:00').split(':');
  return `${String(Number(hour) || 0).padStart(2, '0')}:${String(Number(minute) || 0).padStart(2, '0')}`;
}
